module.exports = __webpack_public_path__ + "img/backButton.120aa914.png";